export class UserPermissionRequest {
  userId: number;
  emailId: string;
  aadObjectId: string;
  role: string;
  status: string;
  defaultEloViewVersionId: number;
  enableGatewaySync: boolean = false;
  enableProvisionSync: boolean = false;
  enableEloViewSync: boolean = false;  
  enableEDIOrder: boolean;
  enableBldDetailsUpdate: boolean = false;
  defaultGatewayTypeId : number;
  isActive: boolean;
}
